export function FormField({ label, error, children, hint, required }) {
  return (
    <label className="block">
      {label && (
        <span className="label flex items-center gap-1.5">
          {label}
          {required && <span className="text-brand">*</span>}
        </span>
      )}
      {children}
      {hint && !error && <span className="block text-[11px] text-ink-3 mt-1">{hint}</span>}
      {error && <span className="block text-[11px] text-danger mt-1">{error}</span>}
    </label>
  );
}

export function Switch({ checked, onChange, label, hint }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none">
      <span
        className={`relative mt-0.5 inline-flex w-9 h-5 rounded-full transition-colors ${
          checked ? 'bg-brand' : 'bg-line'
        }`}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <span
          className={`absolute top-0.5 h-4 w-4 rounded-full bg-paper shadow-card transition-transform ${
            checked ? 'translate-x-[18px]' : 'translate-x-0.5'
          }`}
        />
      </span>
      <span className="text-sm">
        <span className="text-ink">{label}</span>
        {hint && <span className="block text-[11px] text-ink-3 mt-0.5">{hint}</span>}
      </span>
    </label>
  );
}
